const FinanceView = () => import("~/views/Finance/Finance.vue")
const OrderBalanceView = () => import("~/views/Finance/OrderBalance/ListView.vue");
const PaymentApplyView = () => import("~/views/Finance/PaymentApply/ListView.vue");
const PaymentApplyDetail = () => import("~/views/Finance/PaymentApply/DetailView.vue");
const RemittanceView = () => import("~/views/Finance/Remittance/ListView.vue");
const RemittanceDetail = () => import("~/views/Finance/Remittance/DetailView.vue");
const PaymentOrderView = () => import("~/views/Finance/PaymentOrder/ListView.vue");
const OrderContractView = () => import("~/views/Finance/OrderContract/ListView.vue");
const OrderContractDetail = () => import("~/views/Finance/OrderContract/DetailView.vue")

export {
  FinanceView,
  OrderBalanceView,
  PaymentApplyView,
  RemittanceView,
  PaymentOrderView,
  OrderContractView,

  OrderContractDetail,
  PaymentApplyDetail,
  RemittanceDetail,
};
